import baseService from "../BaseService";
import mixinsMessage from "@/mixins/message";
import QhPrevisaoLinha from "@/model/qh/QhPrevisaoLinha";
export default {
  listarPorPlano(idPlano) {
    return baseService
      .get("/api/qh-previsoes", { params: { idPlano: idPlano } })
      .then(response => {
        if (response && response.data) {
          return response.data.map(d => new QhPrevisaoLinha(d));
        }
        return [];
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar listar previsões", error);
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  listarFuncionariosDisponiveis(idPlano, idTipoFuncao) {
    return baseService
      .get("/api/qh-previsoes/funcionarios-disponiveis", {
        params: { idPlano: idPlano, idTipoFuncao: idTipoFuncao || null }
      })
      .then(response => {
        if (response && response.data) {
          return response.data.map(d => new QhPrevisaoLinha(d));
        }
        return [];
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar listar funcionários disponíveis", error);
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  listarFuncoesDisponiveis(idPlano) {
    return baseService
      .get("/api/qh-previsoes/funcoes-disponiveis", {
        params: { idPlano: idPlano }
      })
      .then(response => {
        if (response && response.data) {
          return response.data;
        }
        return [];
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar listar funções disponíveis", error);
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  buscarPorId(idPrevisao) {
    return baseService
      .get("/api/qh-previsoes/" + idPrevisao)
      .then(response => {
        if (response && response.data) {
          return new QhPrevisaoLinha(response.data);
        }
        return null;
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar carregar previsão", error);
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  incluirLote(idPlano, itens) {
    return baseService
      .post("/api/qh-previsoes/lote/" + idPlano, itens)
      .then(response => {
        mixinsMessage.methods.success(response.data);
        return response.data;
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar incluir previsões em lote", error);
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  alterar(previsao) {
    return baseService
      .put("/api/qh-previsoes/" + previsao.id, previsao)
      .then(response => {
        mixinsMessage.methods.success(response.data);
        return response.data;
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar atualizar previsão", error);
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  excluir(previsao) {
    return baseService
      .delete("/api/qh-previsoes/" + previsao.id)
      .then(response => {
        mixinsMessage.methods.success(response.data);
        return response.data;
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar excluir previsão", error);
        // eslint-disable-next-line no-console
        console.error(error);
      });
  }
};
